import { useCallback, useEffect, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export const Gallery = ({ images, alt }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true });
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    if (!emblaApi) return;
    const onSelect = () => setIdx(emblaApi.selectedScrollSnap());
    emblaApi.on("select", onSelect);
    return () => emblaApi.off("select", onSelect);
  }, [emblaApi]);

  const goTo = useCallback((i) => emblaApi && emblaApi.scrollTo(i), [emblaApi]);

  if (!images || images.length === 0) return null;
  if (images.length === 1)
    return (
      <div className="border border-[#27272A] overflow-hidden">
        <img src={images[0]} alt={alt} className="w-full aspect-[4/3] object-cover" data-testid="deal-detail-image" />
      </div>
    );

  return (
    <div>
      <div className="relative border border-[#27272A]">
        <div className="overflow-hidden" ref={emblaRef} data-testid="deal-gallery">
          <div className="flex touch-pan-y">
            {images.map((src, i) => (
              <div key={i} className="flex-[0_0_100%] min-w-0">
                <img src={src} alt={`${alt} — photo ${i + 1}`} className="w-full aspect-[4/3] object-cover" data-testid={i === 0 ? "deal-detail-image" : undefined} />
              </div>
            ))}
          </div>
        </div>
        <button data-testid="gallery-prev-button" onClick={() => emblaApi && emblaApi.scrollPrev()} className="absolute left-3 top-1/2 -translate-y-1/2 bg-black/70 border border-[#27272A] p-2 hover:border-[#FFCC00] hover:text-[#FFCC00]">
          <ChevronLeft size={18} />
        </button>
        <button data-testid="gallery-next-button" onClick={() => emblaApi && emblaApi.scrollNext()} className="absolute right-3 top-1/2 -translate-y-1/2 bg-black/70 border border-[#27272A] p-2 hover:border-[#FFCC00] hover:text-[#FFCC00]">
          <ChevronRight size={18} />
        </button>
        <div className="absolute bottom-3 right-3 bg-black/70 text-[11px] px-2 py-1 tabular-nums" data-testid="gallery-counter">
          {idx + 1} / {images.length}
        </div>
      </div>
      <div className="grid grid-cols-5 gap-2 mt-2">
        {images.map((src, i) => (
          <button
            key={i}
            data-testid={`gallery-thumb-${i}`}
            onClick={() => goTo(i)}
            className={`border overflow-hidden ${i === idx ? "border-[#FFCC00]" : "border-[#27272A] opacity-60 hover:opacity-100"}`}
          >
            <img src={src} alt="" className="w-full aspect-square object-cover" />
          </button>
        ))}
      </div>
    </div>
  );
};
